import { useQueryClient } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';
import { useBaseSupportMutation } from './baseMutation';

export const useAddIntegrationMutation = (
    bind: string,
    setNewSoftwares: (newSoftware: string[]) => void,
) => {
    const queryClient = useQueryClient();
    return useBaseSupportMutation(
        (integrations: string[]) =>
            RQAPICall({
                endpoint: `support/${bind}/integrations`,
                method: 'POST',
                body: integrations.map((integration) => ({
                    slug: integration,
                })),
            }),
        () => {
            queryClient.invalidateQueries({
                queryKey: ['client-integration', bind],
            });
            setNewSoftwares([]);
        },
    );
};

export const useAddIntegrationMutationOnCreation = () =>
    useBaseSupportMutation(
        ({ integrations, bind }: { integrations: string[]; bind: string }) =>
            RQAPICall({
                endpoint: `support/${bind}/integrations`,
                method: 'POST',
                body: integrations.map((integration) => ({
                    slug: integration,
                })),
            }),
        () => {},
    );
